import React, { useState, useEffect } from 'react';
import {
  Modal,
  Box,
  Tabs,
  Tab,
  Typography,
  IconButton,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../context/CurrencyContext';


const radioStyle = {
  '&.Mui-checked': {
    color: '#4CAF50',
  },
};

const tabStyle = {
  '&.Mui-selected': {
    color: '#4CAF50',
  },
};

interface SettingsProps {
  open: boolean;
  onClose: () => void;
  sx?: object;
}

const Settings: React.FC<SettingsProps> = ({ open, onClose }) => {
  const { i18n } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const { selectedCurrency, setSelectedCurrency } = useCurrency();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
  };

  const handleCurrencyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedCurrency = event.target.value;
    setSelectedCurrency(selectedCurrency);
    
    localStorage.setItem('selectedCurrency', selectedCurrency);
  };

  useEffect(() => {
    const storedCurrency = localStorage.getItem('selectedCurrency');
    if (storedCurrency) {
      setSelectedCurrency(storedCurrency);
    } else {
      setSelectedCurrency('MIXTO'); 
    }
  }, [setSelectedCurrency]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: {xs:'70%', sm:'60%', md:'50%', lg:'35%'},
        mawidth: 700,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '10px'
      }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 16, top: 16 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" component="h2" gutterBottom>
          Configuración
        </Typography>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          sx={{ mb: 0 }}
          TabIndicatorProps={{ style: { background: '#4CAF50' } }}
        >
          <Tab label="Idioma" sx={tabStyle} />
          <Tab label="Moneda" sx={tabStyle} />
        </Tabs>
        <Box sx={{ borderBottom: '1px solid #ccc', mb: 3 }} />

        {tabIndex === 0 && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Selecciona un idioma:
            </Typography>
            <FormControl component="fieldset">
              <RadioGroup value={i18n.language} onChange={handleLanguageChange} row>
                <FormControlLabel
                  value="es"
                  control={<Radio sx={radioStyle} />}
                  label="Español"
                />
                <FormControlLabel
                  value="en"
                  control={<Radio sx={radioStyle} />}
                  label="Inglés"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        )}
        {tabIndex === 1 && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Selecciona una moneda:
            </Typography>
            <FormControl component="fieldset">
              <RadioGroup value={selectedCurrency} onChange={handleCurrencyChange} row>
                <FormControlLabel
                  value="CRC"
                  control={<Radio sx={radioStyle} />}
                  label="Colones (₡)"
                />
                <FormControlLabel
                  value="USD"
                  control={<Radio sx={radioStyle} />}
                  label="Dólares ($)"
                />
                <FormControlLabel
                  value="MIXTO"
                  control={<Radio sx={radioStyle} />}
                  label="Mixto"
                />

              </RadioGroup>
            </FormControl>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default Settings;
